import React from 'react';

const TypingAnimation = ({ className = "text-primary", text = "Typing" }) => {
    return (
        <span className={`flex items-center ${className}`}>
            <span>{text}</span>
            <span className="ml-1 flex space-x-0.5">
                <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
                <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
                <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
            </span>
        </span>
    );
};

export default TypingAnimation;